import { withInstall } from '@code-monkey-ui/utils'

import Rate from './src/rate.vue'

export const ElRate = withInstall(Rate)
export default ElRate

export * from './src/rate'
